import React from 'react';
import { bool, string, node, func } from 'prop-types';
import { translate } from 'react-i18next';
import classnames from 'classnames/bind';

import styles from './SectionNavigationItem.scss';
const cx = classnames.bind(styles);

function SectionNavigationItem({
  active,
  name,
  icon,
  heading: title,
  className,
  onClick,
  isSticky,
}) {
  const handleClick = event => {
    event.preventDefault();
    onClick(name);
  };
  return (
    <a
      href={`#${name}`}
      className={cx(styles.root, className, {
        active,
        isSticky,
      })}
      onClick={handleClick}
    >
      {icon && (
        <img
          className={styles.icon}
          src={icon}
          width={48}
          height={48}
          aria-hidden
        />
      )}
      <h6 className={styles.title}>{title}</h6>
    </a>
  );
}

SectionNavigationItem.propTypes = {
  active: bool.isRequired,
  heading: string.isRequired,
  name: string.isRequired,
  onClick: func.isRequired,
  className: string,
  icon: node,
  isSticky: bool,
};

SectionNavigationItem.defaultProps = {
  className: null,
  icon: null,
  isSticky: false,
};

export default translate(['premium'])(SectionNavigationItem);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/SectionNavigationItem/SectionNavigationItem.jsx